module.exports = __webpack_public_path__ + "media/logos/crains-logo-white-testimonial-5506c4dc.png";